import DOMPurify from "dompurify";

interface SanitizeResult {
  sanitizedSVG: string;
  wasPurified: boolean;
}
export const sanitizeSVG = async (file: File): Promise<SanitizeResult> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const svgContent = reader.result as string;

      DOMPurify.removed = [];

      const sanitizedSVG = DOMPurify.sanitize(svgContent, {
        USE_PROFILES: { svg: true, svgFilters: true },
        ALLOWED_TAGS: [
          "svg",
          "circle",
          "rect",
          "path",
          "line",
          "polygon",
          "polyline",
          "text",
          "g",
          "defs",
          "use",
          "image",
          "clipPath",
          "filter",
          "feGaussianBlur",
          "feOffset",
          "feBlend",
          "feComposite",
          "feColorMatrix",
          "feFlood",
          "feMerge",
          "feMergeNode",
        ],
        ALLOWED_ATTR: [
          "width",
          "height",
          "viewBox",
          "fill",
          "stroke",
          "stroke-width",
          "transform",
          "x",
          "y",
          "cx",
          "cy",
          "r",
          "d",
          "points",
          "xlink:href",
          "clip-path",
          "style",
          "result",
          "in",
          "in2",
          "stdDeviation",
          "mode",
        ],
      });

      const wasPurified = DOMPurify.removed.length > 0;

      if (!sanitizedSVG) {
        reject(
          new Error(
            "Sanitization failed or produced empty output. The SVG might be invalid or disallowed."
          )
        );
      } else {
        resolve({ sanitizedSVG, wasPurified });
      }
    };
    reader.onerror = () => reject(new Error("Failed to read SVG file"));
    reader.readAsText(file);
  });
};
